module.exports = __webpack_public_path__ + "static/case_11-85eed07af0fa9ff65ebec6d40456fa72.jpg";